<template>
  <div>
    <svg
      version="1.2"
      width="150.88mm"
      height="25.09mm"
      viewBox="2706 9246 15088 2509"
      preserveAspectRatio="xMidYMid"
      fill-rule="evenodd"
      stroke-width="28.222"
      stroke-linejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:ooo="http://xml.openoffice.org/svg/export"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns:presentation="http://sun.com/xmlns/staroffice/presentation"
      xmlns:smil="http://www.w3.org/2001/SMIL20/"
      xmlns:anim="urn:oasis:names:tc:opendocument:xmlns:animation:1.0"
      xml:space="preserve"
    >
      <defs>
        <linearGradient
          id="logo-gradient"
          gradientTransform="rotate(180)"
          x1="0%"
          y1="0%"
          x2="50%"
          y2="100%"
        >

          <stop
            offset="0%"
            stop-color="#ffffff"
          >
            <animate
              attributeName="stop-color"
              values="#ffffff; #A0A0A0; #ffffff"
              dur="2s"
              repeatCount="indefinite"
            />
          </stop>

          <stop
            offset="100%"
            stop-color="#A0A0A0"
          >
            <animate
              attributeName="stop-color"
              values="#A0A0A0; #ffffff; #A0A0A0"
              dur="2s"
              repeatCount="indefinite"
            />
          </stop>

        </linearGradient>
      </defs>
      <g class="Page">
        <g class="com.sun.star.drawing.ClosedBezierShape">
          <g id="id3">
            <rect
              class="BoundingBox"
              stroke="none"
              fill="none"
              x="2706"
              y="9247"
              width="2317"
              height="2507"
            />
            <path
              fill="url('#logo-gradient')"
              stroke="none"
              d="M 5022,9423 L 5022,11577 C 5022,11674 4943,11753 4846,11753 L 2884,11753 C 2786,11753 2707,11674 2707,11577 L 2707,9423 C 2707,9326 2786,9247 2884,9247 2981,9247 3060,9326 3060,9423 L 3060,11400 4669,11400 4669,9423 C 4669,9326 4748,9247 4846,9247 4943,9247 5022,9326 5022,9423 Z"
            />
          </g>
        </g>
        <g class="com.sun.star.drawing.ClosedBezierShape">
          <g id="id4">
            <rect
              class="BoundingBox"
              stroke="none"
              fill="none"
              x="8240"
              y="9821"
              width="355"
              height="1934"
            />
            <path
              fill="url('#logo-gradient')"
              stroke="none"
              d="M 8594,9998 L 8594,11577 C 8594,11674 8515,11753 8418,11753 8320,11753 8240,11674 8240,11577 L 8240,9998 C 8240,9900 8320,9821 8418,9821 8515,9821 8594,9900 8594,9998 Z"
            />
          </g>
        </g>
        <g class="com.sun.star.drawing.ClosedBezierShape">
          <g id="id5">
            <rect
              class="BoundingBox"
              stroke="none"
              fill="none"
              x="7260"
              y="9247"
              width="2316"
              height="355"
            />
            <path
              fill="url('#logo-gradient')"
              stroke="none"
              d="M 9575,9424 C 9575,9522 9496,9601 9398,9601 L 7436,9601 C 7339,9601 7260,9522 7260,9424 7260,9326 7339,9247 7436,9247 L 9398,9247 C 9496,9247 9575,9326 9575,9424 Z"
            />
          </g>
        </g>
        <g class="com.sun.star.drawing.ClosedBezierShape">
          <g id="id6">
            <rect
              class="BoundingBox"
              stroke="none"
              fill="none"
              x="5663"
              y="9247"
              width="1904"
              height="2507"
            />
            <path
              fill="url('#logo-gradient')"
              stroke="none"
              d="M 7566,11577 C 7566,11674 7487,11753 7390,11753 L 5839,11753 C 5742,11753 5663,11674 5663,11577 L 5663,9423 C 5663,9326 5742,9247 5839,9247 5938,9247 6017,9326 6017,9423 L 6017,11400 7390,11400 C 7487,11400 7566,11479 7566,11577 Z"
            />
          </g>
        </g>
        <g class="com.sun.star.drawing.ClosedBezierShape">
          <g id="id7">
            <rect
              class="BoundingBox"
              stroke="none"
              fill="none"
              x="15478"
              y="9247"
              width="2316"
              height="2508"
            />
            <path
              fill="url('#logo-gradient')"
              stroke="none"
              d="M 17747,11458 C 17812,11530 17807,11641 17735,11707 17701,11738 17659,11753 17616,11753 17569,11753 17521,11734 17486,11696 L 16635,10761 15785,11696 C 15750,11734 15702,11753 15654,11753 15612,11753 15569,11738 15536,11707 15464,11641 15458,11530 15524,11458 L 17486,9305 C 17552,9232 17663,9227 17735,9293 17807,9359 17812,9470 17747,9542 L 16873,10500 C 16874,10500 16874,10500 16874,10500 L 17747,11458 Z"
            />
          </g>
        </g>
        <g class="com.sun.star.drawing.ClosedBezierShape">
          <g id="id8">
            <rect
              class="BoundingBox"
              stroke="none"
              fill="none"
              x="9979"
              y="9247"
              width="2280"
              height="2507"
            />
            <path
              fill="url('#logo-gradient')"
              stroke="none"
              d="M 12209,11449 C 12276,11520 12273,11632 12202,11699 12168,11731 12124,11748 12080,11748 12034,11748 11987,11729 11953,11693 L 11222,10923 10766,10923 C 10668,10923 10589,10844 10589,10746 10589,10649 10668,10570 10766,10570 L 11302,10570 C 11569,10570 11787,10352 11787,10085 11787,9817 11569,9600 11302,9600 L 10333,9600 10333,11577 C 10333,11674 10254,11753 10156,11753 10058,11753 9979,11674 9979,11577 L 9979,9423 C 9979,9326 10058,9247 10156,9247 L 11302,9247 C 11764,9247 12140,9623 12140,10085 12140,10426 11934,10721 11641,10851 L 12209,11449 Z"
            />
          </g>
        </g>
        <g class="com.sun.star.drawing.ClosedBezierShape">
          <g id="id9">
            <rect
              class="BoundingBox"
              stroke="none"
              fill="none"
              x="15478"
              y="9246"
              width="943"
              height="1001"
            />
            <path
              fill="url('#logo-gradient')"
              stroke="none"
              d="M 15524,9543 C 15458,9470 15464,9359 15536,9293 15609,9227 15720,9232 15786,9305 L 16373,9951 C 16439,10022 16434,10134 16361,10200 16328,10230 16285,10245 16243,10245 16195,10245 16147,10226 16112,10188 L 15524,9543 Z"
            />
          </g>
        </g>
        <g class="com.sun.star.drawing.ClosedBezierShape">
          <g id="id10">
            <rect
              class="BoundingBox"
              stroke="none"
              fill="none"
              x="12604"
              y="9247"
              width="2545"
              height="2508"
            />
            <path
              fill="url('#logo-gradient')"
              stroke="none"
              d="M 15128,11497 C 15172,11584 15137,11690 15051,11734 15025,11747 14998,11753 14971,11753 14907,11753 14844,11718 14813,11657 L 14595,11224 13705,11224 C 13608,11224 13529,11145 13529,11048 13529,10950 13608,10871 13705,10871 L 14415,10871 13878,9812 12938,11657 C 12893,11744 12787,11778 12700,11734 12614,11690 12579,11584 12623,11497 L 13721,9343 C 13751,9284 13812,9247 13878,9247 L 13879,9247 C 13945,9247 14006,9284 14036,9343 L 14858,10963 C 14861,10968 14863,10974 14866,10979 L 15128,11497 Z"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'AnimatedLogo'
}
</script>
